module.exports = __webpack_public_path__ + "img/ne.0c432227.svg";